import { useCrmApiClient } from '../Programs/CrmApi'
import { useQuery } from '@tanstack/react-query'

// Query for organisations linked to the site for a specific business Area
// (site is determined by used crm api token)
const useSiteAreaOrganisations = (businessArea) => {
  const client = useCrmApiClient()

  return useQuery({
    queryKey: ['site', 'area', businessArea, 'organisations'],
    queryFn: () => {
      return client.fetchSiteAreaOrganisations({ businessArea })
    },
  })
}

export default useSiteAreaOrganisations
